import ConfirmBookingModal from './ConfirmBookingModal';
export default ConfirmBookingModal;